// Cuestionario de Autodiagnóstico "Alza Tu Voz" - LAB XXI
// Todas las preguntas son de tipo escala 1-5

export const questions = [
  // CONVOCATORIA
  { 
    id: "CON.1", 
    dimension: "Convocatoria", 
    text: "En tu proyecto, cuando lanzan una nueva convocatoria, suelen aparecer los mismos adolescentes de siempre y cuesta llegar a grupos diversos. ¿Qué tan frecuente es esta situación?",
    textEn: "In your project, when launching a new call, do the same adolescents usually appear and it's difficult to reach diverse groups. How often does this happen?",
    type: "scale_1_5" 
  },
  { 
    id: "CON.2", 
    dimension: "Convocatoria", 
    text: "¿Han tenido problemas para asegurar que la convocatoria realmente llegue a adolescentes de distintos lugares o contextos (barrios lejanos, comunidades)?",
    textEn: "Have you had problems ensuring that the call actually reaches adolescents from different places or contexts (distant neighborhoods, communities)?",
    type: "scale_1_5" 
  },
  { 
    id: "CON.3", 
    dimension: "Convocatoria", 
    text: "En las convocatorias, ¿trabajan junto a aliados locales (escuelas, radios comunitarias) para difundir la información?",
    textEn: "In the calls, do you work with local allies (schools, community radios) to spread the information?",
    type: "scale_1_5" 
  },
  // COMUNICACIÓN
  { 
    id: "COM.1", 
    dimension: "Comunicación", 
    text: "Los materiales de convocatoria, ¿a veces suenan muy institucionales o poco atractivos para los adolescentes?",
    textEn: "Do the call materials sometimes sound too institutional or unattractive to adolescents?",
    type: "scale_1_5" 
  },
  { 
    id: "COM.2", 
    dimension: "Comunicación", 
    text: "¿Sienten que el lenguaje o las imágenes que usan no siempre conectan con la realidad del territorio?",
    textEn: "Do you feel that the language or images you use don't always connect with the territory's reality?",
    type: "scale_1_5" 
  },
  { 
    id: "COM.3", 
    dimension: "Comunicación", 
    text: "Al trabajar en territorios con lenguas locales, ¿les cuesta adaptar los mensajes a esos registros?",
    textEn: "When working in territories with local languages, is it difficult to adapt messages to those registers?",
    type: "scale_1_5" 
  },
  // METODOLOGÍAS
  { 
    id: "M.1", 
    dimension: "Metodologías", 
    text: "En las actividades, ¿a veces las dinámicas no funcionan, el grupo se aburre o las instrucciones son confusas?",
    textEn: "In activities, do dynamics sometimes not work, the group gets bored, or instructions are confusing?",
    type: "scale_1_5" 
  },
  { 
    id: "M.2", 
    dimension: "Metodologías", 
    text: "¿Ocurre que inician actividades sin haber construido acuerdos de convivencia previos?",
    textEn: "Does it happen that you start activities without having built prior coexistence agreements?",
    type: "scale_1_5" 
  },
  { 
    id: "M.3", 
    dimension: "Metodologías", 
    text: "¿Notan que algunas personas participan mucho mientras otras permanecen calladas?",
    textEn: "Do you notice that some people participate a lot while others remain silent?",
    type: "scale_1_5" 
  },
  { 
    id: "M.4", 
    dimension: "Metodologías", 
    text: "¿Las personas adultas suelen tener más voz o protagonismo que los adolescentes durante las actividades?",
    textEn: "Do adults tend to have more voice or prominence than adolescents during activities?",
    type: "scale_1_5" 
  },
  // LOGÍSTICA
  { 
    id: "L.1", 
    dimension: "Logística", 
    text: "¿La distancia o la falta de transporte afecta la asistencia de ciertos participantes?",
    textEn: "Does distance or lack of transportation affect certain participants' attendance?",
    type: "scale_1_5" 
  },
  { 
    id: "L.2", 
    dimension: "Logística", 
    text: "¿Han notado que la falta de alimentación afecta la energía y concentración del grupo?",
    textEn: "Have you noticed that lack of food affects the group's energy and concentration?",
    type: "scale_1_5" 
  },
  { 
    id: "L.3", 
    dimension: "Logística", 
    text: "¿El costo personal de participar genera deserción?",
    textEn: "Does the personal cost of participating cause dropout?",
    type: "scale_1_5" 
  },
  // ALIADOS EXTERNOS
  { 
    id: "AE.1", 
    dimension: "Aliados externos", 
    text: "¿Han tenido dificultades para mantener informadas o tranquilas a las familias sobre las actividades?",
    textEn: "Have you had difficulties keeping families informed or calm about the activities?",
    type: "scale_1_5" 
  },
  { 
    id: "AE.2", 
    dimension: "Aliados externos", 
    text: "¿Han enfrentado situaciones donde algún adolescente necesitaba apoyo emocional y no sabían a quién acudir?",
    textEn: "Have you faced situations where an adolescent needed emotional support and you didn't know who to turn to?",
    type: "scale_1_5" 
  },
  // RETROALIMENTACIÓN
  { 
    id: "R.1", 
    dimension: "Retroalimentación", 
    text: "¿Sienten que las encuestas reciben respuestas cortas, repetitivas o poco sinceras?",
    textEn: "Do you feel that surveys receive short, repetitive, or insincere responses?",
    type: "scale_1_5" 
  },
  { 
    id: "R.2", 
    dimension: "Retroalimentación", 
    text: "¿Al terminar, se quedan sin saber realmente cómo lo vivieron los adolescentes?",
    textEn: "At the end, are you left not really knowing how adolescents experienced it?",
    type: "scale_1_5" 
  },
  { 
    id: "R.3", 
    dimension: "Retroalimentación", 
    text: "Cuando los adolescentes dan ideas, ¿les cuesta integrarlas efectivamente después?",
    textEn: "When adolescents give ideas, is it difficult to effectively integrate them afterwards?",
    type: "scale_1_5" 
  }
];

// Dimensiones con colores y metadatos
export const dimensions = [
  { 
    id: "Convocatoria", 
    color: "hsl(42, 100%, 55%)", 
    icon: "Megaphone",
    description: "Cómo llegamos a adolescentes diversos"
  },
  { 
    id: "Comunicación", 
    color: "hsl(220, 78%, 61%)", 
    icon: "MessageSquare",
    description: "Materiales y lenguaje inclusivo"
  },
  { 
    id: "Metodologías", 
    color: "hsl(36, 100%, 55%)", 
    icon: "Lightbulb",
    description: "Dinámicas y participación equitativa"
  },
  { 
    id: "Logística", 
    color: "hsl(142, 76%, 36%)", 
    icon: "Truck",
    description: "Transporte, alimentación y recursos"
  },
  { 
    id: "Aliados externos", 
    color: "hsl(280, 65%, 60%)", 
    icon: "Users",
    description: "Familias y redes de apoyo"
  },
  { 
    id: "Retroalimentación", 
    color: "hsl(0, 84%, 60%)", 
    icon: "BarChart3",
    description: "Escucha y mejora continua"
  }
];

// Función para obtener preguntas por dimensión
export const getQuestionsByDimension = (dimensionId) => {
  return questions.filter(q => q.dimension === dimensionId);
};

// Función para calcular el puntaje de una dimensión
// INVERSIÓN: Las preguntas miden "frecuencia de barreras" (5 = muchos problemas)
// El Puntaje Final refleja "Nivel de Inclusión" (5 = excelente, 1 = crítico)
// Fórmula: Puntaje Final = 6 - Promedio de Respuestas
export const calculateDimensionScore = (answers, dimensionId) => {
  const dimensionQuestions = getQuestionsByDimension(dimensionId);
  if (dimensionQuestions.length === 0) return 0;
  
  let total = 0;
  let count = 0;
  
  dimensionQuestions.forEach(q => {
    const answer = answers[q.id];
    if (answer !== undefined && answer !== null) {
      // "No sé" vale 1 (asume pocos problemas conocidos)
      total += answer === 0 ? 1 : answer;
      count++;
    }
  });
  
  if (count === 0) return 0;
  
  // Calcular promedio de respuestas (frecuencia de barreras)
  const averageBarriers = total / count;
  
  // Invertir: Puntaje Final = 6 - Promedio
  // Si usuario marca todo "5" (muchos problemas) → 6 - 5 = 1 (Crítico)
  // Si usuario marca todo "1" (pocos problemas) → 6 - 1 = 5 (Excelente)
  const inclusionScore = 6 - averageBarriers;
  
  return inclusionScore;
};

// Función para obtener el nivel de puntaje basado en el Nivel de Inclusión
// Nuevo semáforo:
// 1.0 - 2.5: Área Crítica / Por Explorar (Rojo)
// 2.6 - 3.9: En Proceso (Amarillo)
// 4.0 - 5.0: Fortaleza / Práctica Inclusiva (Verde)
export const getScoreLevel = (score) => {
  if (score >= 4.0) return { level: 'high', label: 'Fortaleza', labelEn: 'Strength' };
  if (score >= 2.6) return { level: 'medium', label: 'En Proceso', labelEn: 'In Progress' };
  return { level: 'low', label: 'Área Crítica', labelEn: 'Critical Area' };
};

export default questions;
